import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface GAIAProductDetailsBadge {
    text?: TypographyPresentationProps;
}

export const productBadgeStyles: GAIAProductDetailsBadge = {
    text: {
        css: css`
            background-color: #d76b00;
            padding: 4px 7px;
            border-radius: 28px;
            color: #fff;
            font-size: 0.625rem;
            font-family: "Lato";
            margin-top: 10px;
            margin-bottom: 0.375rem;
            display: inline-block;
        `,
    },
};

const styles = productBadgeStyles;

const GAIAProductDetailsBadge: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    if (!product) {
        return null;
    }
    const { properties } = product;
    return (
        <>
            {properties.badgeBestSeller === "true" ? (
                <Typography as="p" {...styles.text}>
                    Best Seller
                </Typography>
            ) : properties.badgeAwardWinner === "true" ? (
                <Typography as="p" {...styles.text}>
                    Award Winner
                </Typography>
            ) : properties.badgeComingSoon === "true" ? (
                <Typography as="p" {...styles.text}>
                    Coming Soon
                </Typography>
            ) : properties.badgeDiscontinued === "true" ? (
                <Typography as="p" {...styles.text}>
                    Discontinued
                </Typography>
            ) : properties.badgeFinalSale === "true" ? (
                <Typography as="p" {...styles.text}>
                    Final Sale
                </Typography>
            ) : properties.badgeInStoreExclusive === "true" ? (
                <Typography as="p" {...styles.text}>
                    InStore Exclusive
                </Typography>
            ) : properties.badgeNew === "true" ? (
                <Typography as="p" {...styles.text}>
                    New
                </Typography>
            ) : properties.badgeOutofStock === "true" ? (
                <Typography as="p" {...styles.text}>
                    Out of Stock
                </Typography>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(GAIAProductDetailsBadge)),
    definition: {
        displayName: "GAIA Product Badge",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
